var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"TedsLauncherHamburger",on:{"click":function($event){return _vm.$launcher.menu.open()}}},[_c('div',{staticClass:"divit"}),_c('div',{staticClass:"divit"}),_c('div',{staticClass:"divit"})])}
var staticRenderFns = []

export { render, staticRenderFns }